module.exports = __webpack_public_path__ + "static/media/languages-bw.52a54c02.webp";